module.exports = __webpack_public_path__ + "img/instagram.2857f44e.svg";